import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-da503ec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "horizontal-bar-chart" }
const _hoisted_2 = { class: "bar-wrapper" }
const _hoisted_3 = { class: "bar-label" }

import { computed } from "vue";

export interface CategoryCountDataItem {
  key: string;
  value: number;
  colour: string;
}

export type CategoryCountData = CategoryCountDataItem[];


export default /*#__PURE__*/_defineComponent({
  __name: 'horizontal-bar-chart',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

const orderedData = computed(() => {
  return props.data?.slice().sort((a, b) => {
    return b.value - a.value;
  });
});

const maxValue = computed(() => {
  return Math.max(...(props.data?.map((i) => i.value) ?? 0));
});

const sumOfValues = computed(() => {
  return props.data?.reduce((sum, item) => {
    return sum + (item.value || 0);
  }, 0);
});

function barWidth(item: CategoryCountDataItem): string {
  const fraction = item.value / maxValue.value;
  return `${fraction * 100}%`;
}

function percentage(value: number): string {
  return sumOfValues.value <= 0 ? "" : `${Math.round((value * 100) / sumOfValues.value)}%`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedData.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "chart-item",
        key: item.key + ''
      }, [
        _createElementVNode("p", null, _toDisplayString(item.key), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "bar",
            style: _normalizeStyle({ 'width': barWidth(item), 'background-color': item.colour })
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.value) + " (" + _toDisplayString(percentage(item.value)) + ")", 1)
          ], 4)
        ])
      ]))
    }), 128))
  ]))
}
}

})